import { render, staticRenderFns } from "./PublicJuntaDirectivaDetail.vue?vue&type=template&id=06b347ba&scoped=true"
import script from "./PublicJuntaDirectivaDetail.vue?vue&type=script&lang=js"
export * from "./PublicJuntaDirectivaDetail.vue?vue&type=script&lang=js"
import style0 from "./PublicJuntaDirectivaDetail.vue?vue&type=style&index=0&id=06b347ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b347ba",
  null
  
)

export default component.exports